<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import SignupForm from './components/Signup/Form.vue';
import Logo from 'dashboard/components-next/icon/Logo.vue';

const store = useStore();
const globalConfig = computed(() => store.getters['globalConfig/get']);

const isDark = ref(document.documentElement.classList.contains('dark'));
const croworkLetterLogo = '/brand-assets/CROWORKLETTER.png';

const toggleTheme = () => {
  isDark.value = !isDark.value;
  window.dispatchEvent(
    new CustomEvent('crow-theme-toggle', {
      detail: isDark.value ? 'dark' : 'light',
    })
  );
};
</script>

<template>
  <main
    class="flex flex-col w-full min-h-screen py-20 bg-n-brand/5 dark:bg-n-background sm:px-6 lg:px-8"
  >
    <button
      type="button"
      :aria-label="isDark ? 'Switch to light mode' : 'Switch to dark mode'"
      class="fixed top-4 right-4 z-50 inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/80 dark:bg-n-solid-2 shadow-md hover:shadow-lg transition text-n-slate-12 dark:text-n-slate-11 border border-n-weak"
      @click="toggleTheme"
    >
      <svg
        v-if="isDark"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path
          d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    </button>

    <section class="max-w-5xl mx-auto">
      <Logo
        video-src="/brand-assets/crowork2.webm"
        :video-scale="1.2"
        :alt="globalConfig.installationName"
        class="block w-auto h-44 sm:h-56 mx-auto dark:brightness-0 dark:invert"
      />
      <img
        :src="croworkLetterLogo"
        :alt="globalConfig.installationName"
        class="block w-auto h-14 sm:h-16 mx-auto mt-3"
      />
      <p class="mt-3 text-sm text-center text-n-slate-11">
        {{ $t('REGISTER.HAVE_AN_ACCOUNT') }}{{ ' ' }}
        <router-link to="/app/login" class="lowercase text-link text-n-brand">
          {{ $t('LOGIN.SUBMIT') }}
        </router-link>
      </p>
    </section>

    <section
      class="bg-white shadow sm:mx-auto mt-11 sm:w-full sm:max-w-lg dark:bg-n-solid-2 p-11 sm:shadow-lg sm:rounded-lg"
    >
      <h2 class="mb-6 text-2xl font-semibold text-n-slate-12">
        {{ $t('REGISTER.GET_STARTED') }}
      </h2>
      <SignupForm />
    </section>
  </main>
</template>
